import { render, staticRenderFns } from "./previewCard4.vue?vue&type=template&id=dfce1020&scoped=true"
import script from "./previewCard4.vue?vue&type=script&lang=js"
export * from "./previewCard4.vue?vue&type=script&lang=js"
import style0 from "./previewCard4.vue?vue&type=style&index=0&id=dfce1020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfce1020",
  null
  
)

export default component.exports